import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { useCart } from "../lib/CartContext";
import { formatPrice, imgUrl } from "../lib/api";

export default function ProductCard({ product, idx = 0 }) {
  const { add, toggleWishlist, isWishlisted } = useCart();
  const wished = isWishlisted(product.id);

  return (
    <article className="product-card group fade-up" style={{ animationDelay: `${idx * 60}ms` }} data-testid={`product-card-${product.id}`}>
      <Link to={`/products/${product.id}`} className="block relative aspect-[4/5] overflow-hidden bg-[#0a0a0a]">
        <img
          src={imgUrl(product.images?.[0]) || "https://images.unsplash.com/photo-1627899590758-9a41d43d49e6?q=85"}
          alt={product.name}
          className="image-zoom absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        {product.rare && (
          <span className="absolute top-4 left-4 label-luxe text-[#D4AF37] bg-black/60 px-3 py-1.5 backdrop-blur-sm border border-[#D4AF37]/40">Rar</span>
        )}
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(product.id); }}
          className={`absolute top-4 right-4 w-10 h-10 flex items-center justify-center transition ${wished ? "bg-[#D4AF37] text-black" : "bg-black/50 text-[#D4AF37] backdrop-blur-sm border border-[#D4AF37]/30"}`}
          aria-label="Wishlist"
          data-testid={`wishlist-toggle-${product.id}`}
        >
          <Heart size={14} strokeWidth={1.4} fill={wished ? "currentColor" : "none"} />
        </button>
        <button
          onClick={(e) => { e.preventDefault(); add(product.id, 1); }}
          className="absolute bottom-0 left-0 right-0 bg-[#D4AF37] text-black py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-500 text-[11px] uppercase tracking-[0.25em] flex items-center justify-center gap-2"
          data-testid={`quick-add-${product.id}`}
        >
          <ShoppingBag size={13} strokeWidth={1.6} /> Adaugă în Coș
        </button>
      </Link>
      <div className="p-5">
        <p className="label-luxe text-[#A39E8A] mb-2">{product.category}</p>
        <h3 className="font-serif text-xl text-[#F8F4E6] leading-snug min-h-[3rem] line-clamp-2">
          <Link to={`/products/${product.id}`} className="hover:text-[#D4AF37] transition">{product.name}</Link>
        </h3>
        <div className="flex items-baseline justify-between mt-4 pt-4 border-t border-[#D4AF37]/10">
          <span className="font-serif text-2xl text-[#D4AF37]">{formatPrice(product.price, product.currency)}</span>
          {product.rating > 0 && <span className="text-[10px] text-[#A39E8A] tracking-[0.2em] uppercase">★ {product.rating.toFixed(1)}</span>}
        </div>
      </div>
    </article>
  );
}
